// 📄 src/utils/config.ts
import { log } from "./debug";
import { STORYCORE_VERSION as VERSION } from "../core/version";
export { VERSION as STORYCORE_VERSION };

function getMetaContent(name: string): string | null {
  const meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  return meta?.content?.trim() || null;
}

/**
 * Dynamically determines the base URL from the script tag path.
 * You can override this logic in production by hardcoding.
 */
export function getBaseUrl(): string {
  const base = getMetaContent("storycore-base");
  if (base) {
    log("[CONFIG] Resolved baseUrl from meta tag:", base);
    return base;
  }

  console.warn("[CONFIG] No meta tag found for baseUrl. Falling back to '/'");
  return "/";
}

export function initStoryCorePaths(): void {
  const base = getBaseUrl().replace(/\/$/, "");
  const videoCdn = (getMetaContent("storycore-cdn") || base).replace(/\/$/, "");
  const imageCdn = (getMetaContent("storycore-cdn-images") || base).replace(/\/$/, "");
  const audioCdn = (getMetaContent("storycore-cdn-audio") || base).replace(/\/$/, "");
  const likesMeta = getMetaContent("storycore-likes-api");
  const likesApi = (() => {
    if (!likesMeta) return `${base}/api/likes`;
    if (/^https?:\/\//i.test(likesMeta)) return likesMeta;
    const trimmed = likesMeta.replace(/^\/+/, "");
    return `${base}/${trimmed}`;
  })();

  (window as any).STORYCORE_BASE_URL = base;
  (window as any).STORYCORE_AUDIO_BASE = audioCdn;
  (window as any).STORYCORE_VIDEO_BASE = videoCdn;
  (window as any).STORYCORE_IMAGE_BASE = imageCdn;

  (window as any).STORYCORE_AUDIO_PATH = `${audioCdn}/audio`;
  (window as any).STORYCORE_VIDEO_PATH = `${videoCdn}/videos`;
  (window as any).STORYCORE_IMAGE_PATH = `${imageCdn}/images`;
  (window as any).STORYCORE_ICON_PATH = `${base}/icons`;
  (window as any).__STORYCORE_LIKES_API__ = likesApi;
}

/** Media directory paths resolved at runtime */
export const audioDir = (window as any).STORYCORE_AUDIO_PATH;
export const videoDir = (window as any).STORYCORE_VIDEO_PATH;
export const imageDir = (window as any).STORYCORE_IMAGE_PATH;
export const iconDir  = (window as any).STORYCORE_ICON_PATH;

export const audioBase = (window as any).STORYCORE_AUDIO_BASE;
export const videoBase = (window as any).STORYCORE_VIDEO_BASE;
export const imageBase = (window as any).STORYCORE_IMAGE_BASE;

/**
 * Checks if the story is running in 'reader' mode.
 */
export const isReaderMode: boolean = window.location.search.includes("mode=read");
